const state = {
  step: 1,
  totalSteps: 4,
  showOnboarding: true
};
const mutations = {
  NEXT_STEP: state => {
    state.step++
  },
  FINISH: state => {
    state.welcomeDialog = true
  },
  SELECTED_STEP: (state, payload) => {
    state.step = payload
  },
  SET_SHOW_ONBOARDING: (state, payload) => {
    state.showOnboarding = payload
  }
};
const actions = {
  nextStep: ({ commit }) => {
    commit("NEXT_STEP")
  },
  finish: ({ commit }) => {
    commit("FINISH")
  },
  selectedStep: ({ commit }, payload) => {
    commit("SELECTED_STEP", payload)
  },
  showOnboarding:({commit}, payload) => {
    commit("SET_SHOW_ONBOARDING", payload)
  }
};
const getters = {
  showOnboarding: (state) => state.showOnboarding,
};

export default {
  state,
  mutations,
  actions,
  getters
}